import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Analytics } from "@vercel/analytics/react";
import HomePage from "@/pages/HomePage";
import GalleryPage from "@/pages/GalleryPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import Layout from "@/components/Layout";
import AdminLayout from "@/components/AdminLayout";
import { AuthProvider } from "@/context/AuthContext";
import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Route>
          
          {/* Admin Routes */}
          <Route path="/getin" element={<AdminLogin />} />
          <Route path="/getin/dashboard" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
        </Routes>
        <Toaster position="top-right" richColors />
        <Analytics />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
